/*
 * @Author: zwcong
 * @Description:
 * @Date: 2021-12-07 17:25:44
 * @LastEditTime: 2022-03-18 17:30:44
 * @FilePath: /teacher-h5/src/service/studentsDetails/index-url.js
 */
let baseUrl = ''
// const passportUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = ''
} else {
  baseUrl = 'https://jzx.aixuexi.com'
  // passportUrl = 'https://www.aixuexi.com'
}

export default {
  // 科目年级筛选项
  querySubjectGrade: `${baseUrl}/teaching/api/lesson/querySubjectGrade`,
  // 讲次详细信息
  queryLessonList: `${baseUrl}/teaching/api/lesson/queryLessonList`,
  // 学情报告
  report: studentUserId => `${baseUrl}/teaching/api/student/lessons/report/${studentUserId}`,
  // 自我巩固
  consolidation: studentUserId => `${baseUrl}/teaching/api/student/lessons/consolidation/${studentUserId}`,
  // 错题本
  book: studentUserId => `${baseUrl}/teaching/api/student/lessons/book/${studentUserId}`,
  // 答题记录
  queryLessonsAnswerRecords: `${baseUrl}/teaching/api/student/lessons/answers`,
  // 金币流水
  operationCoinRecord: `${baseUrl}/teaching/api/coin/operationCoinRecord`,
  // 操作金币
  operationCoin: `${baseUrl}/teaching/api/coin/operationCoin`,
  // 自我巩固-详情
  getConsolidationDetails: (lessonId, studentUserId, groupId) => `${baseUrl}/teaching/api/student/lessons/${lessonId}/consolidation/new/${studentUserId}/${groupId}`,
  // 错题本-详情
  getBookDetails: (lessonId, studentUserId, groupId) => `${baseUrl}/teaching/api/student/lessons/${lessonId}/book/${studentUserId}/${groupId}`,
  // 学员档案详情
  getStudentDetail: `${baseUrl}/teaching/api/student/detail`,
  // 学员汇总
  studentSummary: studentUserId => `${baseUrl}/teaching/api/student/studentSummary/${studentUserId}`,
  // 删除讲次
  delLesson: `${baseUrl}/teaching/api/lesson/delLesson`,
  // 上课/下课
  lessonRecord: `${baseUrl}/teaching/api/lesson/lessonRecord`,
  // 更新讲次信息-拖拽
  changeLesson: `${baseUrl}/teaching/api/lesson/changeLesson`,
  // 学生学习卡详情
  studentCardDetail: studentUserId => `${baseUrl}/teaching/api/student/studentCardDetail/${studentUserId}`
}
